import { cx } from "@emotion/css";
import { TableHead, TableHeadProps } from "@mui/material";

import makeStyles from "../../../makeStylesV4Compat";
const useStyles = makeStyles((theme) => ({
  root: {
    background: "none",
    "&:not(:last-child)": {
      borderRight: `1px solid ${theme.palette.divider}`,
    },
  },
}));

export function WireTableHead(props: TableHeadProps): JSX.Element {
  const classes = useStyles();
  return <TableHead {...props} className={cx(classes.root, props.className)} />;
}
